/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Feature_Priority_SupportInputs */

const en_pricing_feature_priority_support = /** @type {(inputs: Pricing_Feature_Priority_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priority support`)
};

const de_pricing_feature_priority_support = /** @type {(inputs: Pricing_Feature_Priority_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prioritäts-Support`)
};

const fr_pricing_feature_priority_support = /** @type {(inputs: Pricing_Feature_Priority_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Support prioritaire`)
};

const es_pricing_feature_priority_support = /** @type {(inputs: Pricing_Feature_Priority_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soporte prioritario`)
};

const it_pricing_feature_priority_support = /** @type {(inputs: Pricing_Feature_Priority_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supporto prioritario`)
};

const nl_pricing_feature_priority_support = /** @type {(inputs: Pricing_Feature_Priority_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prioriteitsondersteuning`)
};

const pl_pricing_feature_priority_support = /** @type {(inputs: Pricing_Feature_Priority_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wsparcie priorytetowe`)
};

const fi_pricing_feature_priority_support = /** @type {(inputs: Pricing_Feature_Priority_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etusijatuen`)
};

const da_pricing_feature_priority_support = /** @type {(inputs: Pricing_Feature_Priority_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prioriteret support`)
};

const sv_pricing_feature_priority_support = /** @type {(inputs: Pricing_Feature_Priority_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prioritetsupport`)
};

/**
* | output |
* | --- |
* | "Priority support" |
*
* @param {Pricing_Feature_Priority_SupportInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_feature_priority_support = /** @type {((inputs?: Pricing_Feature_Priority_SupportInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Feature_Priority_SupportInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_feature_priority_support(inputs)
	if (locale === "fr") return fr_pricing_feature_priority_support(inputs)
	if (locale === "es") return es_pricing_feature_priority_support(inputs)
	if (locale === "it") return it_pricing_feature_priority_support(inputs)
	if (locale === "nl") return nl_pricing_feature_priority_support(inputs)
	if (locale === "pl") return pl_pricing_feature_priority_support(inputs)
	if (locale === "fi") return fi_pricing_feature_priority_support(inputs)
	if (locale === "da") return da_pricing_feature_priority_support(inputs)
	if (locale === "sv") return sv_pricing_feature_priority_support(inputs)
	return en_pricing_feature_priority_support(inputs)
});